import updateExerciseAction from 'modules/training/modules/training-exercises/actions/update'
import { EXERCISE_KEY } from 'modules/training/models/exercise/constants'

function updateSecondaryMusclesExerciseAction (instance, value) {
  return updateExerciseAction({
    key: EXERCISE_KEY.SECONDARY_MUSCLES,
    value: value,
    instance
  })
}

export default updateSecondaryMusclesExerciseAction
